import { useEffect, useState } from "react";
import { CertificateData, getCertificate } from "../remote/scan_data"
import { Button, CircularProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

export interface CertificateProps {
	id: string
	data?: CertificateData | undefined
	hideChildren?: boolean
}

export const CertificateSimple = ({id, data=undefined}: CertificateProps) => {
	const navigate = useNavigate()

	const [certificateData, setCertificateData] = useState<CertificateData | null | undefined>(data);
	useEffect(() => {
		if (data == undefined) {
			getCertificate(id, (data, resp) => {
				if (data) {
					setCertificateData(data);
				} else {
					setCertificateData(null);
				}
			});
		}
	}, [setCertificateData]);

	return (certificateData
		? <Button onClick={() => navigate(`/tree/certificate/${id}`)}>
			<Typography variant="body1" fontWeight={700} marginRight='1em'>Certificate</Typography>{certificateData.subject_an}
			</Button>
		: <CircularProgress />
	)
}

export const Certificate = ({id, data = undefined, hideChildren = false}: CertificateProps) => {
	const navigate = useNavigate()

	const [certificateData, setCertificateData] = useState<CertificateData | null | undefined>(data);
	useEffect(() => {
		if (data == undefined) {
			getCertificate(id, (data, resp) => {
				if (data) {
					setCertificateData(data);
				} else {
					setCertificateData(null);
				}
			});
		}
	}, [setCertificateData]);

	return (certificateData
		? <TableContainer component={Paper}>
			<Table width={hideChildren ? 'auto' : '100%'}>
				<TableHead>
					<TableRow>
						<TableCell>
							<Typography variant="h5">Certificate</Typography>
						</TableCell>
						<TableCell align='right'>
							{hideChildren ? (<></>) :
							(certificateData.children.length > 0 ?
							<Button onClick={() => navigate(`/tree/certificate/${id}`)}>See children</Button>
							: <Button disabled>No children</Button>)}
						</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
				<TableRow><TableCell align='left'>Serial Number</TableCell><TableCell align='right'>{certificateData.serial}</TableCell></TableRow>
				<TableRow><TableCell align='left'>Fingerprint (sha256)</TableCell><TableCell align='right'>{certificateData.fingerprint_sha256}</TableCell></TableRow>
				<TableRow><TableCell align='left'>Issuer DN</TableCell><TableCell align='right'>{certificateData.issuer_dn}</TableCell></TableRow>
				<TableRow><TableCell align='left'>Subject DN</TableCell><TableCell align='right'>{certificateData.subject_dn}</TableCell></TableRow>
				<TableRow><TableCell align='left'>Subject AN</TableCell><TableCell align='right'>{certificateData.subject_an}</TableCell></TableRow>
				<TableRow><TableCell align='left'>Not Before</TableCell><TableCell align='right'>{String(certificateData.not_before)}</TableCell></TableRow>
				<TableRow><TableCell align='left'>Not After</TableCell><TableCell align='right'>{String(certificateData.not_after)}</TableCell></TableRow>
				<TableRow><TableCell align='left'>First seen</TableCell><TableCell align='right'>{String(certificateData.first_seen)}</TableCell></TableRow>
				<TableRow><TableCell align='left'>Last seen</TableCell><TableCell align='right'>{String(certificateData.last_seen)}</TableCell></TableRow>
				</TableBody>
			</Table>
			</TableContainer>
		: <CircularProgress />
	)
}
